// Filename: public/BIEventsFunctions.js 
import { biLoggerFactory } from 'wix-private';

const msid = "e2c193c6-23dc-499c-8fd8-3b0c13359ee3"; //replace the value between quotes with your site msid value

const biGroupsLoggers1 = {
    19: biLoggerFactory('get-started', 19, { msid }),
}

const biGroupsLoggers2 = {
    19: biLoggerFactory('fb-ads-lp', 19, { msid })
}

const biGroupsLoggers3 = {
    19: biLoggerFactory('traffic-guide', 19, { msid })
}

export async function fireBIEvent1(src, evid, fields) {

    const biLogger = biGroupsLoggers1[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);

    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}

export async function fireBIEvent2(src, evid, fields) {

    const biLogger = biGroupsLoggers2[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);

    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}


export async function fireBIEvent3(src, evid, fields) {

    const biLogger = biGroupsLoggers3[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);

    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}